import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ConductCarnival from "./conductCarnival";
import { getCarnivalList } from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
  carnivalList: state.ConductCampReducer.carnivalList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCarnivalList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ConductCarnival);
